import type {Builder} from '@wix/document-services-types'
import {SKIP_STYLE_LIST, STYLE_TYPE_MAP} from '../constants/style'
import {convertDMVariableToCSSValue} from '../dataMappers'
import type {PresetVariableData} from '../types'

export interface IPresetsStylesTransformer {
    transformPresetStyles(presetVariables: Record<string, PresetVariableData>): Builder.StyleOverrides
}

type StyleOverridesValue = Builder.StyleOverrides[string]

export class PresetsStylesTransformer implements IPresetsStylesTransformer {
    transformPresetStyles(presetVariables: Record<string, PresetVariableData>): Builder.StyleOverrides {
        const styleEntries = Object.values(presetVariables)
            .map(entry => this.processVariableStyle(entry))
            .filter((entry): entry is [string, StyleOverridesValue] => entry !== null)

        return Object.fromEntries(styleEntries)
    }

    private processVariableStyle(presetData: PresetVariableData): [string, StyleOverridesValue] | null {
        if (!presetData?.type) {
            return null
        }

        const styleItem = STYLE_TYPE_MAP[presetData.type]
        const skippedStyle = SKIP_STYLE_LIST.includes(presetData.type)

        if (!styleItem || skippedStyle) {
            return null
        }

        const cssValue = convertDMVariableToCSSValue(styleItem, presetData.value) as string

        if (!cssValue) {
            return null
        }

        return [presetData.id, {defaultValue: cssValue}]
    }
}
